@if (offerDetails) {
  <div class="offer-container">
    <div class="img-container">
      <img src="{{ offerDetails.image_url }}" alt="Tickmark" />
    </div>
    <div class="offer-details">
      @if (offerDetails.code; as code) {
        <div class="code-container">
          {{ code }}
          <img class="code-copy" (click)="copyCode(offerDetails.code)"
            src="{{ DEPLOY_URL }}/assets/images/offer-copy.svg" />
        </div>
      }
      <div class="offer-text-container">
        <span class="offer-text-heading">
          {{ offerDetails.offer_text_heading }}
        </span>
        <p class="offer-text">
          {{ offerDetails.offer_text }}
        </p>
      </div>
      <button class="lets-go-cta" (click)="close()">Let's Go!</button>
    </div>
  </div>
}